import { message } from "antd";
import { client } from "../../../actions";
import { authHeader } from "../../../helpers/auth-header";

const changePassword = async ({
	oldPassword,
	newPassword,
	confirmPassword,
}) => {
	try {
		const response = await client.post(
			"/Profile/change_password",
			{
				oldPassword,
				newPassword,
				confirmPassword,
			},
			{
				headers: authHeader(),
			}
		);
		if (response.data.result === "Error") {
			message.error(response.data.message);
			return false;
		} else {
			message.success("Пароль изменён");
			return true;
		}
	} catch (e) {
		console.error(e);
		message.error("Произошла ошибка");
		return false;
	}
};

export default changePassword;
